<template>
  <div class="page-contact-pro">
    <section class="page-contact__form-section">
      <div class="form-section container">
        <h1 class="form-section__title">
          {{ $t('title') }}
        </h1>
        <p class="form-section__subtitle">
          {{ $t('form-title') }}
        </p>

        <div class="form-section__wrapper">
          <div class="form-section__column form-section__form">
            <div class="form__container container">
              <ContactProForm
                confirmation-path="/contact-opnemen-bedrijf/bevestigd"
              />

              <p class="mt-11">
                {{ $t('phoneButtonTitle') }}
              </p>

              <a
                id="contact-pro-phone-button"
                v-track-click
                class="t-btn text-primary border border-primary rounded hover:bg-primary/20 mt-5"
                :href="$t('phoneLink')"
              >
                <svg
                  class="mr-2 h-6 w-6"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.9999 16.9201V19.9201C22.0011 20.1986 21.944 20.4743 21.8324 20.7294C21.7209 20.9846 21.5572 21.2137 21.352 21.402C21.1468 21.5902 20.9045 21.7336 20.6407 21.8228C20.3769 21.912 20.0973 21.9452 19.8199 21.9201C16.7428 21.5857 13.7869 20.5342 11.1899 18.8501C8.77376 17.3148 6.72527 15.2663 5.18993 12.8501C3.49991 10.2413 2.44818 7.27109 2.11993 4.1801C2.09494 3.90356 2.12781 3.62486 2.21643 3.36172C2.30506 3.09859 2.4475 2.85679 2.6347 2.65172C2.82189 2.44665 3.04974 2.28281 3.30372 2.17062C3.55771 2.05843 3.83227 2.00036 4.10993 2.0001H7.10993C7.59524 1.99532 8.06572 2.16718 8.43369 2.48363C8.80166 2.80008 9.04201 3.23954 9.10993 3.7201C9.23656 4.68016 9.47138 5.62282 9.80993 6.5301C9.94448 6.88802 9.9736 7.27701 9.89384 7.65098C9.81408 8.02494 9.6288 8.36821 9.35993 8.6401L8.08993 9.9101C9.51349 12.4136 11.5864 14.4865 14.0899 15.9101L15.3599 14.6401C15.6318 14.3712 15.9751 14.1859 16.3491 14.1062C16.723 14.0264 17.112 14.0556 17.4699 14.1901C18.3772 14.5286 19.3199 14.7635 20.2799 14.8901C20.7657 14.9586 21.2093 15.2033 21.5265 15.5776C21.8436 15.9519 22.0121 16.4297 21.9999 16.9201Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                {{ $t('phoneReadable') }}
              </a>
            </div>
          </div>

          <div class="form-section__column form-section__info">
            <MapNetherlands :text="$t('mapText')" />

            <p class="info__body">
              {{ $t('mapSubtitle') }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="container pb-12 md:py-20">
      <hr class="hidden md:block border-primary" />

      <h2
        class="text-2xl leading-8 font-semibold text-center md:text-left text-primary pt-4 md:pt-20"
      >
        {{ $t('uspsTitle') }}
      </h2>
      <p class="text-center md:text-left leading-5 mt-4">
        {{ $t('uspsSubtitle') }}
      </p>

      <div class="mt-12 md:mt-16 w-full flex flex-col md:flex-row gap-y-9">
        <div
          v-for="usp of usps"
          :key="usp.text"
          class="flex md:flex-col items-center md:w-1/4"
        >
          <div>
            <div
              class="flex items-center justify-center h-10 w-10 rounded-full bg-primary text-white"
            >
              <component :is="usp.icon" class="h-6 w-6" />
            </div>
          </div>
          <p class="ml-3 leading-5 md:ml-0 md:mt-3 md:text-center">
            {{ $t(usp.text) }}
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContactProForm from 'chimera/all/themes/jupiter/components/ContactProForm'
import MapNetherlands from 'chimera/all/components/lottie/MapNetherlands'
import IconLocation from 'chimera/all/themes/jupiter/images/icons/IconLocation'
import IconCart from 'chimera/all/themes/jupiter/images/icons/IconCart'
import IconQuotes from 'chimera/all/themes/jupiter/images/icons/IconQuotes'
import IconNoContract from 'chimera/all/themes/jupiter/images/icons/IconNoContract'

export default {
  name: 'ContactPage',

  components: {
    ContactProForm,
    MapNetherlands,
    IconLocation,
    IconCart,
    IconQuotes,
    IconNoContract,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Aanmelden als partner',
      headDescription:
        'Wil je ook leads ontvangen van Dewoningwaardecheck.nl? Meld je dan aan via het contactformulier. Contact opnemen met geïnteresseerden in jouw regio is mogelijk!',
      path: '/contact-opnemen-bedrijf',
      usps: [
        {
          icon: IconLocation,
          text: 'usps1-text',
        },
        {
          icon: IconCart,
          text: 'usps2-text',
        },
        {
          icon: IconQuotes,
          text: 'usps3-text',
        },
        {
          icon: IconNoContract,
          text: 'usps4-text',
        },
      ],
    }
  },
}
</script>

<i18n>
{
  "nl-NL": {
    "title": "Dagelijks koppelen wij aanvragen van particulieren en bedrijven aan onze professionals.",
    "form-title": "Sluit je nu aan als pro!",
    "phoneButtonTitle": "Of bel ons als je met ons team wilt praten:",
    "phoneLink": "tel:+31762007001",
    "phoneReadable": "(0)76 200 70 01",
    "mapText": "heeft een makelaar nodig",
    "mapSubtitle": "Elke dag zijn meer dan 1000 particulieren en bedrijven op zoek naar onze professionals",
    "uspsTitle": "Wij bieden jou nieuwe klanten aan",
    "uspsSubtitle": "Profiteer van het voordeel van een alles-in-één marketingoplossing. Wij helpen jouw klantenbestand groeien.",
    "usps1-text": "Potentiële klanten uit jouw eigen werkgebied!",
    "usps2-text": "Bepaal zelf hoeveel aanvragen je wilt ontvangen.",
    "usps3-text": "Ontvang kwalitatieve offerte aanvragen.",
    "usps4-text": "Gratis inschrijven en geen contractduur."
  },
  "en-GB": {
    "title": "Every day we link requests from individuals and companies to our professionals.",
    "form-title": "Join as a pro now!",
    "phoneButtonTitle": "Or, if you’d like to talk to our team, give us a call:",
    "phoneLink": "tel:+31762007001",
    "phoneReadable": "(0)76 200 70 01",
    "mapText": "needs a real estate agent.",
    "mapSubtitle": "Every day more than 1000 individuals and companies are looking for our professionals",
    "uspsTitle": "We offer you new customers",
    "uspsSubtitle": "Take advantage of an all-in-one marketing solution. We help your customer base grow.",
    "usps1-text": "Potential customers from your own work area!",
    "usps2-text": "Decide for yourself how many requests you want to receive.",
    "usps3-text": "Receive quality quote requests.",
    "usps4-text": "Free registration and no contract duration."
  }
}
</i18n>
